// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chamado-container-principal {
    background: var(--cinza-claro);
    color: var(--text-color);
    height: 4rem;
    transition: all .3s ease-in-out;
}

.chamado-container-principal:last-child {
    border-radius: 0 0 8px 8px;
}

.chamado-container-principal:first-child {
    border-radius: 8px 8px 0 0;
}

#filho-unico {
    border-radius: 8px;
}

.checkbox-chamado {
    padding-left: 1rem;
}

.info-principal-chamado {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.nome-e-numero-chamado-container {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.nome-chamado {
    color: var(--cinza-em-aberto);
}

.numero-chamado {
    color: var(--cinza-padrao);
}

.responsavel-e-status-chamado {
    padding-right: 2.5rem;
}

.container-todas-informacoes {
    display: flex;
    gap: 1.2rem;
    height: 100%;
    align-items: center;
    justify-content: center;
}

.checkbox-container-sozinho {
    display: flex;
    height: 100%;
    align-items: center;
}

/* Estilos ocultos (somente visíveis com o hover) */
.div-complementar-todas-informacoes {
    display: flex;
    flex-direction: column;
}

.container-info-adicional-chamado {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 3rem;
}

.info-adicional-chamado {
    display: none;
    /* display: flex; */
    flex-direction: row;
    color: var(--cinza-em-aberto);
    font-size: .8rem;
    transition: all .3s ease-in-out;
    gap: .3rem;
}

.chamado-container-principal {
    background: var(--cinza-claro-hover);
    transition: all .3s ease-in-out;

    .div-complementar-todas-informacoes {
        gap: .4rem;
    }   

    .info-adicional-chamado {
        transition: all .3s ease-in-out;
        display: flex;
    }
}

.chamado-container-principal:hover {
    background: var(--cinza-hover);
}

.vence-em-prazo, .vence-em-prazo {
    color: var(--error-color);
}

/* Definindo as cores com base no tipoListaChamado */
.chamado-container-principal.emAberto {
    border-left: 1rem solid var(--cinza-em-aberto);
}

.chamado-container-principal.emAndamento {
    border-left: 1rem solid var(--azul-dixi);
}

.chamado-container-principal.aguardandoResposta {
    border-left: 1rem solid var(--aguardando-resposta-color);
}

.chamado-container-principal.finalizado {
    border-left: 1rem solid var(--finalizado-color);
}

.chamado-container-principal.emAnalise {
    border-left: 1rem solid var(--em-analise-color);
}

.chamado-container-principal.congelado {
    border-left: 1rem solid var(--congelado-color);
}`, "",{"version":3,"sources":["webpack://./src/components/ChamadoList/ChamadoList.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;;IAE/B;QACI,UAAU;IACd;;IAEA;QACI,+BAA+B;QAC/B,aAAa;IACjB;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,oDAAoD;AACpD;IACI,8CAA8C;AAClD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,8CAA8C;AAClD","sourcesContent":[".chamado-container-principal {\n    background: var(--cinza-claro);\n    color: var(--text-color);\n    height: 4rem;\n    transition: all .3s ease-in-out;\n}\n\n.chamado-container-principal:last-child {\n    border-radius: 0 0 8px 8px;\n}\n\n.chamado-container-principal:first-child {\n    border-radius: 8px 8px 0 0;\n}\n\n#filho-unico {\n    border-radius: 8px;\n}\n\n.checkbox-chamado {\n    padding-left: 1rem;\n}\n\n.info-principal-chamado {\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.nome-e-numero-chamado-container {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.nome-chamado {\n    color: var(--cinza-em-aberto);\n}\n\n.numero-chamado {\n    color: var(--cinza-padrao);\n}\n\n.responsavel-e-status-chamado {\n    padding-right: 2.5rem;\n}\n\n.container-todas-informacoes {\n    display: flex;\n    gap: 1.2rem;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.checkbox-container-sozinho {\n    display: flex;\n    height: 100%;\n    align-items: center;\n}\n\n/* Estilos ocultos (somente visíveis com o hover) */\n.div-complementar-todas-informacoes {\n    display: flex;\n    flex-direction: column;\n}\n\n.container-info-adicional-chamado {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    gap: 3rem;\n}\n\n.info-adicional-chamado {\n    display: none;\n    /* display: flex; */\n    flex-direction: row;\n    color: var(--cinza-em-aberto);\n    font-size: .8rem;\n    transition: all .3s ease-in-out;\n    gap: .3rem;\n}\n\n.chamado-container-principal {\n    background: var(--cinza-claro-hover);\n    transition: all .3s ease-in-out;\n\n    .div-complementar-todas-informacoes {\n        gap: .4rem;\n    }   \n\n    .info-adicional-chamado {\n        transition: all .3s ease-in-out;\n        display: flex;\n    }\n}\n\n.chamado-container-principal:hover {\n    background: var(--cinza-hover);\n}\n\n.vence-em-prazo, .vence-em-prazo {\n    color: var(--error-color);\n}\n\n/* Definindo as cores com base no tipoListaChamado */\n.chamado-container-principal.emAberto {\n    border-left: 1rem solid var(--cinza-em-aberto);\n}\n\n.chamado-container-principal.emAndamento {\n    border-left: 1rem solid var(--azul-dixi);\n}\n\n.chamado-container-principal.aguardandoResposta {\n    border-left: 1rem solid var(--aguardando-resposta-color);\n}\n\n.chamado-container-principal.finalizado {\n    border-left: 1rem solid var(--finalizado-color);\n}\n\n.chamado-container-principal.emAnalise {\n    border-left: 1rem solid var(--em-analise-color);\n}\n\n.chamado-container-principal.congelado {\n    border-left: 1rem solid var(--congelado-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
